import DynamicTable from '@/common/components/DynamicTable/DynamicTable';
import type { ColumnsType } from 'antd/es/table';
import { API_ENDPOINTS, QUERY_KEYS } from '../../api/apiEndpoints';
import type { InvoiceLineItem, invoiceTypeList } from '../../types/invoiceTypeList';
import FormatLocalDate from '../../../../common/components/FormatLocalDate';
import Confirmation from '../../../../common/components/ConfirmButton';
import { CheckCircleFilled } from '@ant-design/icons';
import StatusTag from '../../../../common/components/Status';
import dayjs from 'dayjs';
import { t } from 'i18next';

const myActions = [
    {
        render: (record: invoiceTypeList) => {
            return (
                <>
                {
                    record?.status?.toLowerCase() === "unpaid" ? (
                            <Confirmation
                                apiUrl={API_ENDPOINTS.INVOICE.SEARCH_UPDATE}
                                id={record.id}
                                title={t("Mark as Paid")}
                                icon={<CheckCircleFilled />}
                                method="post"
                                payloadKey='Id'
                                extraPayload={{ Status: "Paid" }}
                                confirmButtonText={t("Please confirm do you want to update the status of this invoice to Paid??")}
                                queryKey={QUERY_KEYS.INVOICE.INVOICE}
                                successMessage={t("Status Paid successfully")}
                />
                    ) : null}
                </>
            )
        },
    },
];

//<InvoicePrintButton invoice={record} />

const childColumns: ColumnsType<InvoiceLineItem> = [
    { title: "Card No", dataIndex: "cardNumber", key: "cardNumber" },
    { title: "Name", dataIndex: "name", key: "name" },
    { title: "DOB", dataIndex: "dob", key: "dob", render: (text: string) => (text ? dayjs(text).format('DD-MM-YYYY') : '') },
    { title: t("Age"), dataIndex: "age", key: "age" },
    { title: "Gender", dataIndex: "gender", key: "gender" },
    { title: t("Marital Status"), dataIndex: "maritalStatus", key: "maritalStatus" },
    { title: "Category", dataIndex: "category", key: "category" },
    { title: t("Amount"), dataIndex: "amount", key: "amount" },
    { title: "EffectiveDate", dataIndex: "effectiveDate", key: "effectiveDate", render: (text: string) => (text ? dayjs(text).format('DD-MM-YYYY') : '') },
    { title: "Satus", dataIndex: "status", key: "status", render: (status: string) => (<StatusTag status={status} />),},
];

// ---------- Expandable Row ----------
const expandedRowRender = (record: invoiceTypeList) => {
    return (
        <div style={{ margin: "0px 25px" }}>
            <DynamicTable<InvoiceLineItem>
                key={record.id}
                tableTitle={`${t("Invoice")}: ${record.id}`}
                dataApiUrl={API_ENDPOINTS.INVOICE.GET_INVOICE_ITEM}
                baseQueryKey={["CompanyDetailList", String(record.id)]}
                columns={childColumns}
                showActions={false}
                extraParameters={{ Id: record.id }}
                filterConfigs={[
                    {
                        field: "searchBy", placeholder: "Select option", type: 'select', showSearch: true,
                        options: [
                            { label: 'Name', value: 'Name' }
                        ]
                    },
                    { field: "Name", placeholder: "Search by  name", type: 'input' }
                ]}
            />
        </div>
    );
};

const Invoice = () => {
    const InvoiceColumns: ColumnsType<invoiceTypeList> = [
        { title: 'Name', dataIndex: 'name', key: 'name' },
        { title: 'Plan Name', dataIndex: 'planName', key: 'planName'},
        { title: 'Invoice Date', dataIndex: 'invoiceDate', key: 'invoiceDate', render: (value: string) => <FormatLocalDate value={value} format="DD-MM-YYYY" />, },
        { title: 'Due Date', dataIndex: 'dueDate', key: 'dueDate', render: (value: string) => <FormatLocalDate value={value} format="DD-MM-YYYY" />, },
        {
            title: 'Total Amount', dataIndex: 'totalAmount', key: 'totalAmount',
            render: (value: number, record: invoiceTypeList) =>
                `${value.toLocaleString()} ${record?.currencyISOCode != null ? record?.currencyISOCode : ""}`,
        },
        { title: "Satus", dataIndex: "status", key: "status", render: (status: string) => (<StatusTag status={status} />), },
    ];

    return (
        <div>
            <DynamicTable<invoiceTypeList>
                dataApiUrl={API_ENDPOINTS.INVOICE.SEARCH_INVOICE}
                baseQueryKey={QUERY_KEYS.INVOICE.INVOICE}
                columns={InvoiceColumns}
                tableTitle={'Invoice'}
                expandable={{
                    expandedRowRender,
                    rowExpandable: (record) => record.id !== undefined,
                }}
                showActions={{
                    edit: false,
                    delete: false,
                }}
                customActions={myActions}
                filterConfigs={[
                    {
                        field: 'companyId',
                        type: 'select',
                        placeholder: "Select company",
                        showSearch: true,
                        dynamicOptions: {
                            url: "/Lookup/GetDropdownData",
                            method: "POST",
                            body: { "dropdowns": ["company"] },
                            transformData: (apiResponse: unknown) => {
                                const response = apiResponse as { company: { Name: string; Id: number }[] };
                                return response.company.map((item) => ({ label: item.Name, value: item.Id }))
                            }
                        },
                    },
                    {
                        field: "searchBy", placeholder: "Select option", type: 'select', showSearch: true,
                        options: [
                            { label: 'Name', value: 'Name' },
                            { label: 'Plan Name', value: 'PlanName' },
                            { label: 'Group Name', value: 'GroupName' }
                        ]
                    },
                    { field: "searchValue", placeholder: "Search by policy holder name", type: 'input' },
                    {
                        field: "status", placeholder: "Select Status", type: 'select', showSearch: true,

                        options: [
                            { label: 'Paid', value: 'Paid' },
                            { label: 'UnPaid', value: 'UnPaid' },
                            { label: 'Cancelled', value: 'Cancelled' }
                        ]
                    },
                ]}
            />
        </div>
    );
};

export default Invoice;
